/**
 * unidades.js
 */


$('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
    let hash = e.target.hash.substr(1);
    var max = 0;
    $('#' + hash + ' .equal').each(function( index ){
        if ($(this).height() > max) max = $(this).height();
    });
    $('#' + hash + ' .equal').height(max);
});

$('#myTab li:first-child a').tab('show')